// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Mf26+","eusurveyFrame":"styles_eusurveyFrame__cJ-A8"};